import "./cta.css"

const Cta = () => {
  return (
    <div className="mw__cta">
      <div className="mw__cta-content">
        <p>Request Early Access to Get Started</p>
        <h3>Register today & start exploring the endless possiblities.</h3>
      </div>
      <div className="mw__cta-btn">Get Started</div>
    </div>
  )
}

export default Cta